import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/commerce/FacetPerformanceReportingMetrics.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/commerce/reports/private/facet-performance`;
	}
	fetchListingEngagementsPerFacet(e, t) {
		return this.api.get(this.buildPath(`${n.baseUrl}/listing-engagements-per-facet`, {
			...t,
			trackingId: e
		}));
	}
	fetchSearchEngagementsPerFacet(e, t) {
		return this.api.get(this.buildPath(`${n.baseUrl}/search-engagements-per-facet`, {
			...t,
			trackingId: e
		}));
	}
	fetchListingEngagementsPerFacetValue(e, t) {
		return this.api.get(this.buildPath(`${n.baseUrl}/listing-engagements-per-facet-value`, {
			...t,
			trackingId: e
		}));
	}
	fetchSearchEngagementsPerFacetValue(e, t) {
		return this.api.get(this.buildPath(`${n.baseUrl}/search-engagements-per-facet-value`, {
			...t,
			trackingId: e
		}));
	}
	fetchFacetEngagementsPerListing(e, t) {
		return this.api.get(this.buildPath(`${n.baseUrl}/facet-engagements-per-listing`, {
			...t,
			trackingId: e
		}));
	}
	fetchFacetEngagementsPerSearch(e, t) {
		return this.api.get(this.buildPath(`${n.baseUrl}/facet-engagements-per-search`, {
			...t,
			trackingId: e
		}));
	}
};
//#endregion
export { n as FacetPerformanceReportingMetrics };

//# sourceMappingURL=FacetPerformanceReportingMetrics.js.map